import React from 'react';
import { BundleCard } from './BundleCard';
import { MediaSlot } from './MediaSlot';
import { bonuses, mainProduct } from '../../data/artTherapy';
import { bonusCovers, mainProductImage, secondEditionImage } from '../../data/media';
export function Bundle() {
  return <section id="csomag" aria-labelledby="bundle-title" className="scroll-mt-14 bg-peach py-12 md:py-20" data-id="element-13" data-mp="1dmbkbo0atqv0">
      <div className="mx-auto max-w-5xl px-5" data-id="element-14" data-mp="26ctvzdf390k1">
        <div className="mx-auto max-w-xl text-center" data-id="element-15" data-mp="26e4yzb0pm4a3">
          <p className="rounded-full border border-gold-line bg-gold-soft px-5 py-3.5 text-[13px] font-extrabold uppercase leading-relaxed tracking-[0.06em] text-gold" data-id="element-16" data-mp="2bbn04f8hjf7j">
            🎁 A kézikönyved + 6 exkluzív digitális bónusz, ingyen
          </p>
          <h2 id="bundle-title" className="mt-5 font-display text-[1.75rem] font-extrabold leading-[1.2] tracking-[-0.03em] text-ink md:text-4xl" data-id="element-17" data-mp="21c5utyx5b3c3">
            Minden, amire szükséged van, hogy{' '}
            <em className="font-serif font-medium tracking-normal text-lavender-deep" data-id="element-18" data-mp="q0544egq14tp">már ma</em> elkezdd
          </h2>
          <p className="mt-3 text-[17px] leading-relaxed text-body" data-id="element-19" data-mp="ce17zavfma21">
            Azonnali hozzáférés · Egyszeri fizetés · 100% digitális · Bármilyen eszközön elérhető
          </p>
          <p className="mt-5 text-[16px] leading-relaxed text-ink" data-id="element-20" data-mp="le6dtgkz90e3">
            Megkapod a teljes kézikönyvet, 6 bónuszt és egy különleges meglepetést: további 100 új művészetterápiás
            tevékenységet. Minden digitális formátumban, letölthető és nyomtatható.
          </p>
        </div>

        <div className="mx-auto mt-8 max-w-xl" data-id="element-21" data-mp="qb6m7y5auf8d">
          <BundleCard item={mainProduct} image={mainProductImage} slot="main-product" featured data-id="element-22" data-mp="142ux5y3taxnr" />
        </div>

        <div className="mx-auto mt-4 grid max-w-xl gap-4 lg:max-w-none lg:grid-cols-3" data-id="element-23" data-mp="100zlq0s633w9">
          {bonuses.map((b, i) => <BundleCard key={b.badge} item={b} image={bonusCovers[i]} slot={`bonus-${i + 1}`} data-id="element-24" data-mp="1e229chyt8m9a" data-mpi={i} />)}
        </div>

        <div className="mx-auto mt-6 max-w-xl rounded-3xl border border-[#F1E6E0] bg-white px-6 py-6 text-center" data-id="element-25" data-mp="1940rg0d4esze">
          <p className="text-lg font-bold leading-relaxed text-body" data-id="element-26" data-mp="6myjc8g5zq5l">
            A 6 bónusz teljes értéke: <span className="text-body/70 line-through" data-id="element-27" data-mp="aoa9cf2yadeb">16 440 Ft</span> —{' '}
            <span className="text-gold" data-id="element-28" data-mp="fnwmkois3tn4">ma mind ingyen</span> a kézikönyv mellé.
          </p>
        </div>

        <article className="mx-auto mt-6 max-w-xl overflow-hidden rounded-3xl border-2 border-[#2B2F4A] bg-white" data-id="element-29" data-mp="khhfi25ilxfg">
          <div className="px-[17%] pb-4 pt-4" data-id="element-30" data-mp="phlvzs6fas5o">
            <MediaSlot src={secondEditionImage} slot="second-edition" alt="2. kiadás: 100 új művészetterápiás tevékenység" className="rounded-2xl shadow-[0_10px_24px_-14px_rgba(43,47,74,0.6)]" data-id="element-31" data-mp="udb10b17p19d" />
          </div>
          <div className="border-t border-dashed border-lavender-line px-5 pb-6 pt-4" data-id="element-32" data-mp="307u73tbfqa51">
            <span className="block w-fit rounded-full border border-gold-line/60 bg-[#2B2F4A] px-4 py-1.5 text-[13px] font-extrabold uppercase tracking-[0.06em] text-[#F2D27A]" data-id="element-33" data-mp="3565gk2xtiimq">
              ✨ Különleges ajándék — 2. kiadás
            </span>
            <h3 className="mt-3 text-lg font-bold leading-snug text-ink" data-id="element-34" data-mp="2sve6lmr7ald8">100 új művészetterápiás tevékenység</h3>
            <p className="mt-1 text-[16px] leading-relaxed text-body" data-id="element-35" data-mp="2nxmhf0hxxdcq">
              Egy kiegészítő gyűjtemény 100 új kreatív gyakorlattal, még több lehetőséggel a kifejezésre, az önreflexióra és
              az önfelfedezésre.
            </p>
            <span className="mt-3 block w-fit rounded-full border border-gold-line/60 bg-[#2B2F4A] px-4 py-1.5 text-[15px] font-extrabold text-[#F2D27A]" data-id="element-36" data-mp="3bmx8fq9hntdo">
              Ingyen jár az ajánlatod mellé!
            </span>
          </div>
        </article>
      </div>
    </section>;
}